import { Box, Stack } from '@mui/system';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import RndModal from 'src/components/rnd-modal';
import { TwilioError } from 'twilio-video';
import { LiveVisitProvider } from '../../visit/context/LiveVisitContext';
import { ParticipantProvider } from '../context/ParticipantProvider';
import { VideoProvider } from '../context/VideoProvider';
import { useConversationModalContext } from '../hooks/useConversationModalContext';
import ConversationHeader from './ConversationHeader';
import ConversationModalFooter from './ConversationModalFooter';
import ConversationVideo from './ConversationVideo';
import { translateKey } from 'src/locales/translate';


export default function ConversationModal() {
  const {
    state: { open, position, size, maximize },
    onResizeStop,
    onDragStop,
    closeModal,
  } = useConversationModalContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleOnError = useCallback(
    (err: TwilioError | Error) => {
      closeModal();
      if (err && (err as TwilioError).code === 8) {
        enqueueSnackbar(
          translateKey("hardcoded.aby_przeprowadzic_wizyte_wymagany_jest_dostep_do_kamery"),
          { variant: 'error' },
        );
      } else {
        enqueueSnackbar(err.message, { variant: 'error' });
      }
      throw new Error(
        JSON.stringify({
          message: err.message,
          code: (err as TwilioError).code,
        }),
      );
    },
    [closeModal, enqueueSnackbar],
  );

  return (
    <Box
      sx={{
        zIndex: 9999,
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        pointerEvents: 'none',
      }}
    >
      <RndModal
        open={open}
        maximize={maximize}
        position={position}
        size={size}
        onResizeStop={onResizeStop}
        onDragStop={onDragStop}
      >
        <LiveVisitProvider>
          <VideoProvider onError={handleOnError}>
            <ParticipantProvider>
              <Stack sx={{ flex: 1, height: 1, position: 'relative' }}>
                <ConversationHeader />
                <ConversationVideo />
                <ConversationModalFooter />
              </Stack>
            </ParticipantProvider>
          </VideoProvider>
        </LiveVisitProvider>
      </RndModal>
    </Box>
  );
}
